export const wrapStringInSpan = (title: string, searchValue: string = "") => {
  if (!searchValue) {
    return title;
  }

  let formattedTitle = "";
  let start = 0;
  const re = new RegExp(String.raw`${searchValue}`, "gi");
  const substrings = title.match(re) || [];
  for (let i = 0; i < substrings.length; i++) {
    const index = title.indexOf(substrings[i], start);
    formattedTitle += title.slice(start, index);
    formattedTitle += `<span>${title.slice(index, index + searchValue.length)}</span>`;
    start = index + 1;
    const nextIndex = title.indexOf(substrings[i + 1], start);
    formattedTitle += title.slice(
      start - 1 + searchValue.length,
      nextIndex > -1 ? nextIndex : undefined,
    );
  }

  return formattedTitle || title;
};
